module.exports = __webpack_public_path__ + "img/t04.83e9398f.jpg";